import { render } from "./post-smtp-logs-section.vue?vue&type=template&id=82c3bb58&scoped=true"
import script from "./post-smtp-logs-section.vue?vue&type=script&lang=js"
export * from "./post-smtp-logs-section.vue?vue&type=script&lang=js"

import "./post-smtp-logs-section.vue?vue&type=style&index=0&id=82c3bb58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82c3bb58"]])

export default __exports__